module.exports = __webpack_public_path__ + "img/20210906-1630912372823949.1560b79b.png";